import { useLoader } from '@/features/loader/store';
import { useUI } from '@/state/store';
import { NETWORKS } from './networks';
import { useNavigate } from 'react-router';
import { useCatalogueView } from './view';

/** Both modes share one constellation; Example models is a separate Maintenance view. */
export function CatalogueSelect({ maintenance = false }: { maintenance?: boolean }) {
  const navigate = useNavigate();
  const network = useLoader((s) => s.network);
  const profile = useLoader((s) => s.profile);
  const examplesView = useCatalogueView((s) => s.examples);
  const examples = maintenance && (examplesView || network === 'full_catalogue');
  return (
    <select
      aria-label="Network"
      value={examples ? '' : network}
      disabled={profile === 'noaa-core' && !examples}
      className="min-w-0 max-w-[230px] rounded-control bg-transparent px-1 text-xs font-semibold text-ink outline-none focus-visible:ring-1 focus-visible:ring-accent"
      onChange={(e) => {
        useLoader.getState().setNetwork(e.target.value);
        if (maintenance) {
          useCatalogueView.getState().setExamples(false);
          useUI.getState().select({ assetId: null, subsystemId: null });
          navigate('/maintenance');
        }
      }}
    >
      {examples && (
        <option value="" disabled hidden>
          Select constellation
        </option>
      )}
      {NETWORKS.filter((n) => n.group !== 'live' && (profile !== 'noaa-core' || n.id === 'noaa')).map((n) => (
        <option key={n.id} value={n.id}>
          {n.label}
        </option>
      ))}
      {profile !== 'noaa-core' && (
        <optgroup label="Live constellations">
          {NETWORKS.filter((n) => n.group === 'live' && (!maintenance || n.id !== 'full_catalogue')).map((n) => (
            <option key={n.id} value={n.id}>
              {n.label}
            </option>
          ))}
        </optgroup>
      )}
    </select>
  );
}
